import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="yu-baby-error-callback"
export default class extends Controller {
  static values = {
    question: String,
    errorMessage: String
  }
  static outlets = ['yu-baby']

  connect() {
    this.yuBabyOutlet.setErrorMessage({
      question: this.questionValue,
      errorMessage: this.errorMessageValue })
    this.element.remove()
  }
}
